import { Box } from '@mui/material';
import {
    isLocalHost,
    isDev,
    isTestingEnv,
    isPlayground,
    isStaging,
} from '../../../../utils/environmentUtil';

const EnvBanner = () => {
    let envName = 'Localhost';
    if (isLocalHost()) {
        envName = 'Localhost';
    }
    if (isTestingEnv()) {
        envName = 'Testing';
    }
    if (isPlayground()) {
        envName = 'Playground';
    }
    if (isStaging()) {
        envName = 'Staging';
    }

    return isDev() ? (
        <Box
            sx={{
                p: '5px',
                position: 'fixed',
                background: '#3686A0',
                boxShadow: '0 0 0 999px #3686A0',
                clipPath: 'inset(0 -100%)',
                inset: '0 0 auto auto',
                transformOrigin: '0 0',
                transform: 'translate(29.3%) rotate(45deg)',
                zIndex: '999999',
            }}
        >
            <Box
                sx={{
                    fontWeight: 500,
                }}
            >
                {envName}
            </Box>
        </Box>
    ) : null;
};

export default EnvBanner;
